import { render, staticRenderFns } from "./ubbbrrru.vue?vue&type=template&id=4ae44b52"
import script from "./ubbbrrru.vue?vue&type=script&lang=js"
export * from "./ubbbrrru.vue?vue&type=script&lang=js"
import style0 from "./ubbbrrru.vue?vue&type=style&index=0&id=4ae44b52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports